import { render, staticRenderFns } from "./company-notice.vue?vue&type=template&id=c8d14848&"
import script from "./company-notice.vue?vue&type=script&lang=js&"
export * from "./company-notice.vue?vue&type=script&lang=js&"
import style0 from "./company-notice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports